import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DealOverviewPageComponent} from "./deal-overview-page/deal-overview-page.component";
import {SharedModule} from "../shared/shared.module";
import {SellerNewDialogComponent} from "./seller-new-dialog/seller-new-dialog.component";
import {DealDetailsPageComponent} from "./deal-details-page/deal-details-page.component";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatChipsModule} from "@angular/material/chips";
import {MatTableModule} from "@angular/material/table";
import {DealNewDialogComponent} from "./deal-new-dialog/deal-new-dialog.component";
import {DealCopyDialogComponent} from "./deal-copy-dialog/deal-copy-dialog.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDividerModule} from "@angular/material/divider";
import {MatListModule} from "@angular/material/list";
import {MatSidenavModule} from "@angular/material/sidenav";
import {DealFundsComponent} from "./deal-details-page/deal-funds/deal-funds.component";
import {DealFundsManageDialogComponent} from "./deal-details-page/deal-funds-manage-dialog/deal-funds-manage-dialog.component";
import {DealFxRatesDialogComponent} from "./deal-details-page/deal-fx-rates-dialog/deal-fx-rates-dialog.component";
import {DealCashflowsComponent} from "./deal-details-page/deal-cashflows/deal-cashflows.component";
import {DealCashflowTableComponent} from "./deal-details-page/deal-cashflows/deal-cashflow-table/deal-cashflow-table.component";
import {MatTabsModule} from "@angular/material/tabs";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTooltipModule} from "@angular/material/tooltip";
import {DealDetailsComponent} from "./deal-details-page/deal-details/deal-details.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {DealCashflowsGraphComponent} from "./deal-details-page/deal-cashflows-graph/deal-cashflows-graph.component";
import {DealReturnSummaryComponent} from "./deal-details-page/deal-return-summary/deal-return-summary.component";
import {WeightingDivergencePopoverComponent} from "./components/weighting-divergence-popover/weighting-divergence-popover.component";
import {DealCompaniesComponent} from "./deal-details-page/deal-companies/deal-companies.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {BASE_PATH as DEAL_BASE_PATH} from "./generated-sources/api/deal";
import {BASE_PATH as REPORT_BASE_PATH} from "./generated-sources/api/report";
import {DealBubbleChartComponent} from "./deal-details-page/deal-companies/deal-bubble-chart/deal-bubble-chart.component";
import {DealsCompaniesTreemapComponent} from "./deal-details-page/deal-companies/deals-companies-treemap/deals-companies-treemap.component";
import {MatStepperModule} from "@angular/material/stepper";
import {ProjectReportDialogComponent} from "./deal-overview-page/project-report-dialog/project-report-dialog.component";
import {PreviousReportsComponent} from "./deal-overview-page/previous-reports/previous-reports.component";
import {MatMenuModule} from "@angular/material/menu";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ContextMenuComponent} from "../shared/components/context-menu/context-menu.component";
import {FundModule} from "../fund/fund.module";
import {RouterModule} from "@angular/router";

@NgModule({
    declarations: [
        DealOverviewPageComponent,
        SellerNewDialogComponent,
        DealDetailsPageComponent,
        DealNewDialogComponent,
        DealCopyDialogComponent,
        DealFundsComponent,
        DealFundsManageDialogComponent,
        DealFxRatesDialogComponent,
        DealCashflowsComponent,
        DealCashflowTableComponent,
        DealDetailsComponent,
        DealCashflowsGraphComponent,
        DealReturnSummaryComponent,
        DealCompaniesComponent,
        DealBubbleChartComponent,
        DealsCompaniesTreemapComponent,
        ProjectReportDialogComponent,
        PreviousReportsComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatChipsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatDividerModule,
        MatListModule,
        MatSidenavModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatSelectModule,
        MatExpansionModule,
        MatSortModule,
        MatPaginatorModule,
        MatStepperModule,
        MatMenuModule,
        MatCheckboxModule,
        FundModule,
        ContextMenuComponent,
        WeightingDivergencePopoverComponent
    ],
    exports: [
        DealReturnSummaryComponent,
        DealCashflowsComponent,
        DealCashflowsGraphComponent,
    ],
    providers: [
        {provide: DEAL_BASE_PATH, useValue: ".."},
        {provide: REPORT_BASE_PATH, useValue: ".."}
    ]
})
export class DealModule {
}
